import type { Metadata } from "next";
import MyCampaigns from '@/Component/Brand/MyCampaigns'

export const metadata: Metadata = {
    title: "My Campaigns | Connector Club",
    description: "",
};

const MyCampaignsPage = () => {
  return (
    <MyCampaigns />
  )
}

export default MyCampaignsPage
